import { render, staticRenderFns } from "./pushList.vue?vue&type=template&id=5a8cdf3b&scoped=true&"
import script from "./pushList.vue?vue&type=script&lang=js&"
export * from "./pushList.vue?vue&type=script&lang=js&"
import style0 from "./pushList.vue?vue&type=style&index=0&id=5a8cdf3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8cdf3b",
  null
  
)

export default component.exports